<template>
<section class="opportunity">
	<div class="opportunity__content container">
		<div class="content-section__first">
			<h2 class="opportunity__title --fade-in-up" data-vertical-ivp-class="--animate">The Opportunity</h2>
			<ul class="opportunity__text-list --fade-in-up --delay-1" data-vertical-ivp-class="--animate">
				<li class="text-list__item">
					The self-sufficient electric home market could be even larger than 
					electric vehicles, and have a bigger impact on the climate
				</li>
				<li class="text-list__item">
					Pending Inflation Reduction Act includes strong 
					incentives for home electrification and decarbonization
				</li>
				<li class="text-list__item">
					GeoSolar Technologies lets investors get in on the ground 
					floor of this game changing new industry
				</li>
				<li class="text-list__item">
					Only 3% of American homes are powered by residential solar, 
					representing a huge market opportunity to convert the remaining 97%
				</li>
				<li class="text-list__item">
					Zero carbon is the future of home energy
				</li>
			</ul>
			<div class="cta">
				<a class="bottom-text" href="GST_offering_circular.pdf" target="_blank">
					READ OUR OFFERING CIRCULAR
				</a>
				<span class="disclaimer">* Must be over 18, certain states are not currently available and will be added soon.</span>
			</div>
		</div>
		<div class="content-section__second">
		<ul class="list">
			<li class="list__item --fade-in-right" data-vertical-ivp-class="--animate">
				<img src="~@/assets/opportunity/HeatingCooling.png" alt="">
				<div class="info">
					<h3>HEATING & COOLING</h3>
					<p>Integrated floor loops and air ducts provide heating, cooling, and hot water year round.</p>
				</div>
			</li>
			<li class="list__item --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
			<img src="~@/assets/opportunity/Electricity.png" alt="">
				<div class="info">
					<h3>ELECTRICITY</h3>
					<p>Rooftop photovoltaic (PV) solar system sized to provide all the electricity for the home.</p>
				</div>
			</li>
			<li class="list__item --fade-in-right --delay-2" data-vertical-ivp-class="--animate">
				<img src="~@/assets/opportunity/Hvac.png" alt="">
				<div class="info">
					<h3>AIR PURIFICATION</h3>
					<p>CERV(R) Air Filtration for healthy and safe indoor air quality that prevents COVID-19 and other pollutants.</p>
				</div>
			</li>
		</ul>
		</div>
		<CTA class="cta-button" />
	</div>
</section>
</template>

<script>
import CTA from './cta.vue';

export default {
	components: { CTA },
	name: 'Example',
	data () {
		return {
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/opportunity.scss";
</style>
